import { SubscriptionSummary } from "../../../../swagger-gen/web-secured/models/subscription-summary";

export class UserAllowedSubscriptionModel {

    uid: string;
    name: string;

    constructor(res: SubscriptionSummary) {
        this.uid = res.uid;
        this.name = res.name || '';
    }

    public static getListFromApi(res: SubscriptionSummary[]): UserAllowedSubscriptionModel[] {
        const list: UserAllowedSubscriptionModel[] = [];
        if (res) {
            res.forEach(r => {
                list.push(new UserAllowedSubscriptionModel(r));
            });
        }

        return list;
    }
}
